/*eslint-disable*/
import React, {useState} from "react";
import {NavLink as NavLinkRRD, Link} from "react-router-dom";
// nodejs library to set properties for components
import {PropTypes} from "prop-types";
// reactstrap components
import {
	Button,
	Card,
	CardHeader,
	CardBody,
	CardTitle,
	Collapse,
	DropdownMenu,
	DropdownItem,
	UncontrolledDropdown,
	DropdownToggle,
	FormGroup,
	ModalBody,
	Form,
	Input,
	InputGroupAddon,
	InputGroupText,
	InputGroup,
	Media,
	NavbarBrand,
	Navbar,
	NavItem,
	NavLink,
	Nav,
	Progress,
	Table,
	Container,
	Modal,
	Row,
	Col,
} from "reactstrap";
import {motion} from "framer-motion";
import logo from "../../../logo_ncentiva_db.svg";
var ps;

const Sidebar = (props) =>
{
	const [collapseOpen, setCollapseOpen] = useState();
	const [show,setShow] = useState(false);
	// verifies if routeName is the one active (in browser input)
	const activeRoute = (routeName) =>
	{
		return props.location.pathname.indexOf(routeName) > -1 ? "active" : "";
	};
	// toggles collapse between opened and closed (true/false)
	const toggleCollapse = () =>
	{
		setCollapseOpen((data) => !data);
	};
	// closes the collapse
	const closeCollapse = () =>
	{
		setCollapseOpen(false);
	};
	const handleopen = () =>{
		setShow(true)
	}
	const handleClose = () =>{
		setShow(false)
	}
	// creates the links that appear in the left menu / Sidebar
	const createLinks = (routes) =>
	{
		return routes.map((prop, key) =>
		{
			if (!prop.noShow && prop.layout === "/purchaser")
				return (
					<NavItem key={key}>
						<NavLink
							to={prop.layout + prop.path}
							tag={NavLinkRRD}
							onClick={closeCollapse}
							activeClassName="active"
						>
							<div className="border p-2 me-2 new_icon"></div>
							{prop.name}
						</NavLink>
					</NavItem>
				);
			return "";
		});
	};

	const {bgColor, routes} = props;
	let navbarBrandProps;
	const logout = () =>{
		sessionStorage.removeItem("accessToken")
		window.location.href="purchaser-auth/login"
	}

	return (
		<Navbar
			className="navbar-vertical fixed-left navbar-light bg-white"
			expand="md"
			id="sidenav-main"
		>
			<Container fluid>
				{/* Toggler */}
				<button
					className="navbar-toggler"
					type="button"
					onClick={toggleCollapse}
				>
					<span className="navbar-toggler-icon"/>
				</button>
				{/* Brand */}
				<div className="logo-img">
					<motion.img width="200px" height="auto" initial={{opacity: 0, scale: 0.1}} animate={{
						opacity: 1, scale: 1
					}} transition={{duration: 0.8}} src="https://ncentiva-development.s3.eu-west-1.amazonaws.com/ncentiva_new_lowquality_logo.png" alt="Ncentiva"/>
				</div>
				{/* User */}
				<Nav className="align-items-center d-md-none ">
					<UncontrolledDropdown nav>
						<DropdownToggle nav>
								<Media className="align-items-center cursor-pointer">
									<span className="nav-link btn-magnify text-primary" onClick={() => handleopen()}><i class="fas fa-sign-out-alt"></i></span>
								</Media>
						</DropdownToggle>	
					</UncontrolledDropdown>
				</Nav>	
				<Modal
					isOpen={show}
					toggle={handleClose}
					backdrop="static"
					keyboard={false}
					fullscreen="sm"
					size="sm"
					centered
				>
        			<ModalBody>
        				<Col>
							<img className="modal-img"
								src="/assets/images/exclamation.svg"
								// className="img-fluid"
							alt=""
							/>
        				<br />
        				<br />
        				<h1 className="modal-text">Are you sure, you want to Log out?</h1>
        				<br />
        				<div className="modal-row d-flex justify-content-center align-items-center">
            				<Col md ={1}></Col>
            				<Col md={4}>
                				<Button className="btn btn-danger danger-btn" style={{minWidth:"120px"}} onClick={logout}>
                    				<span><b>Yes, Logout</b></span>
                				</Button>
            				</Col>
            				<Col className="middle-col" md ={2}></Col>
            				<Col md={4}>
            					<Button className="btn btn-success success-btn" onClick={handleClose} >
                    				<span><b>Cancel</b></span>
               				 	</Button>
             				</Col>
            				<Col md ={1}></Col>
        				</div>
        				<br />
        				</Col>
        			</ModalBody>
  				</Modal> 
				{/* Collapse */}
				<Collapse navbar isOpen={collapseOpen} className="custom-margin">
					{/* Collapse header */}
					<div className="navbar-collapse-header d-md-none">
						<Row>
							{logo ? (
								<Col className="collapse-brand" xs="6">
									{logo.innerLink ? (
										<Link to={logo.innerLink}>
											<img alt={logo.imgAlt} src={logo.imgSrc}/>
										</Link>
									) : (
										<a href={logo.outterLink}>
											<img alt={logo.imgAlt} src={logo.imgSrc}/>
										</a>
									)}
								</Col>
							) : null}
							<Col className="collapse-close" xs="6">
								<button
									className="navbar-toggler"
									type="button"
									onClick={toggleCollapse}
								>
									<span/>
									<span/>
								</button>
							</Col>
						</Row>
					</div>
					{/* Form */}
					{/* Navigation */}
					<div className="j_purchaser_side_menu">
					<Nav navbar>{createLinks(routes)}</Nav>
					</div>
					{/* Divider */}
					{/* <hr className="my-3"/> */}
				</Collapse>
			</Container>
		</Navbar>
	);
};

Sidebar.defaultProps = {
	routes: [{}],
};

Sidebar.propTypes = {
	// links that will be displayed inside the component
	routes: PropTypes.arrayOf(PropTypes.object),
	logo: PropTypes.shape({
		// innerLink is for links that will direct the user within the app
		// it will be rendered as <Link to="...">...</Link> tag
		innerLink: PropTypes.string,
		// outterLink is for links that will direct the user outside the app
		// it will be rendered as simple <a href="...">...</a> tag
		outterLink: PropTypes.string,
		// the image src of the logo
		imgSrc: PropTypes.string.isRequired,
		// the alt for the img
		imgAlt: PropTypes.string.isRequired,
	}),
};

export default Sidebar;
